import { Injectable } from '@angular/core';
@Injectable()
export class Constant {
  public readonly API_ISITE = 'https://services.internetbuyer.co.uk/REST.svc/GetByProductPartNumber?$format=json';
  //public readonly API_BV ='https://api.bazaarvoice.com/data/reviews.json?apiversion=5.4&passkey=caTfvcAoZxUX1DtyrN1JU9JvSiWXPCXyqVkfE837bPe8k&Filter=ProductId:397273&Include=Products,Comments&Stats=Reviews'
}
